import { useMemo } from "react";
import Select from "react-select";
import { useStock } from "../../context/StockProvider";
import { MdAutorenew, MdError } from "react-icons/md";

const Selectitem = ({ selectedItem, setSelectedItem }) => {
  const { stockItems, stockLoading, stockError } = useStock();

  const itemsList = useMemo(
    () =>
      stockItems.map((item) => ({
        value: item.ItemName,
        label: item.ItemName,
      })),
    [stockItems]
  );

  return (
    <div className="w-80 z-30 space-y-1">
      {!stockLoading && !stockError && (
        <Select
          options={itemsList}
          value={
            itemsList.find((option) => option.value === selectedItem) || null
          }
          onChange={(selectedOption) =>
            setSelectedItem(selectedOption?.value || "")
          }
          placeholder={stockLoading ? "Loading items..." : "Select Item"}
          isSearchable
          isClearable
          isDisabled={stockLoading || !!stockError}
          className="text-sm"
        />
      )}

      {stockLoading && (
        <div className="flex items-center justify-center gap-1.5 text-xs text-blue-600">
          <MdAutorenew className="animate-spin h-3.5 w-3.5" />
          <span>Loading items...</span>
        </div>
      )}

      {stockError && !stockLoading && (
        <div className="flex items-center justify-center gap-1.5 text-xs text-red-600">
          <MdError className="h-3.5 w-3.5 shrink-0" />
          <span>{stockError}</span>
        </div>
      )}
    </div>
  );
};

export default Selectitem;